import React, { useEffect } from "react";
import { useAppSelector } from "../../../../infra/hooks";

interface PropsValue {
  setDaAllActions: (data: any) => void;
}
const DTORecurringPaymentARModal = ({ setDaAllActions }: PropsValue) => {
  const storedAwardsAR = useAppSelector(
    (state) => state.actionRequiredSlice.actionRequiredActions
  );

  useEffect(() => {
    if (storedAwardsAR) setDaAllActions(storedAwardsAR);
  }, []);
  return <></>;
};

export default DTORecurringPaymentARModal;
